export default __webpack_public_path__ + "static/media/alekh.15858752.jpeg";